<template>
  <Breadcrumbs
      title="Dealer Visit Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Dealer Visit Report', path: '/dealer-visit-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <complaintTable />
    </div>
  </div>
</template>

<script>
import complaintTable from './dealervisitTable.vue'
export default {
  name: 'indexList',
  components: {
    complaintTable,
  },
}

</script>
